  let kiwiClone = null;
  function addChartLink(){
    // console.log("addChartLink called")
    if(!document.querySelector('variant-swatch-king').querySelector('._ks_text')){
      const kiwiBtnOriginalElement = document.querySelector('span.ks-chart-modal-link.sizing-chart-modal-link.with-icon')
      const kiwiClonedElement = kiwiBtnOriginalElement.cloneNode(true);
      kiwiClonedElement.id = 'kiwi-cloned-chart-container'; // Change the ID for uniqueness
      kiwiClonedElement.style.display="inline";
      // document.body.appendChild(kiwiClonedElement); 

      const inputElement = document.querySelector('input[name="Size"]');
      if (inputElement) {
        const sizeParentLabel = inputElement.parentElement;
        console.log(sizeParentLabel);
        document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal').style.display="none";
        sizeParentLabel.appendChild(kiwiClonedElement);
        kiwiClonedElement.addEventListener("click", () => {
          console.log("click test");
          // if(document.querySelector('data-dynamic-variants-enabled').querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal').querySelector('._ks_text')){
          //   console.log("CustomKiwiSizingChart click")
          //   document.querySelector('data-dynamic-variants-enabled').querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal').querySelector('._ks_text').click();
          // }
          const allContainers = document.querySelectorAll('.ks-chart-container');
          const outsideContainers = Array.from(allContainers).filter(container => 
              !container.closest('variant-swatch-king')
          );
          const firstOutsideContainer = outsideContainers[0];
          firstOutsideContainer.querySelector('._ks_text').click();
          // console.log('First container outside variant-swatch-king:', firstOutsideContainer);          
        });
      }
    }
  }


function debounceImmediate(func, delay) {
  let timeout;
  let called = false;

  return function(...args) {
    
    if (!called) {
      func.apply(this, args); 
      called = true;
    }

    clearTimeout(timeout);
    
    timeout = setTimeout(() => {
      func.apply(this, args); 
      called = false; 
    }, delay);
  };
}


const debouncedLog = debounceImmediate(() => {
  // console.log("change detected");
  addChartLink();
}, 300);

function newAddVariantMutation() {
  const targetNode = document.querySelector('variant-swatch-king');
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      debouncedLog();
    });
  });
  const config = {
    attributes: true, 
    childList: false,
    subtree: true, 
    attributeFilter: ['class', 'style'] 
  };
  observer.observe(targetNode, config);
}


var productBlocks = document.querySelector(".product-single__meta");
var intervalIdKiwi = setInterval(function () {
    const fetchSwatchKing = document.querySelector('variant-swatch-king')
    console.log('fetchSwatchKing',fetchSwatchKing)
    if(fetchSwatchKing){
      const fetchKiwiSizingChart = document.querySelector('.ks-chart-container.sizing-chart-container.ks-container-with-modal');
    console.log('fetchKiwiSizingChart',fetchKiwiSizingChart)

    if(fetchKiwiSizingChart && fetchSwatchKing.querySelector('[option-name="Size"]')){
      newAddVariantMutation();
      addChartLink()
      clearInterval(intervalIdKiwi);
    }
  }
}, 500);
